import { useState, useEffect, ReactNode } from 'react'

type Tab = {
  label: string;
  child: ReactNode;
};

type TabsProps = {
  tabs: Tab[];
  defaultIndex: number;
};

const Tabs = ({ tabs, defaultIndex }: TabsProps) => {

  const [tabIndex, setTabIndex] = useState(defaultIndex);
  const [child, setChild] = useState(tabs[defaultIndex].child);

  useEffect(() => {
    
    setChild(tabs[tabIndex].child)

    return () => {
    };
  }, [tabIndex, setChild, tabs]);

  return (
    <div>
      <div>
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            id="tabs"
            name="tabs"
            className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            defaultValue={tabs[defaultIndex].label}
          >
            {tabs.map((tab) => (
              <option key={tab.label}>{tab.label}</option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {tabs.map((tab, index) => (
                <button
                  key={tab.label}
                  onClick={()=>setTabIndex(index)}
                  className={
                    tabIndex === index
                      ? 'border-indigo-500 text-indigo-600 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
                  }
                  aria-current={tabIndex === index ? 'page' : undefined}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <div>
        {child}
      </div>        
    </div>
  );
}
export default Tabs;
